import * as React from "react";
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { ManageGroupProps, ManageGroupState, ManageGroupHandler } from './managegroupcomponent';
import { ManageGroupCSSStyleImpl } from './managegroupcss';
import { TextComponent } from '../../../../toolkit/text/textcomponent';
import { MemberDetailsViewModelImpl } from './membersdetails/memberdetailsviewmodel';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';
import { GroupButtonCSSStyleImpl } from './groupbuttoncss';
import { ManageGroupType } from './managegrouptype';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { VerticalListComponent } from '../../../../toolkit/verticallist/verticallistcomponent';
import './manage-groups-style.css';

export interface ManageGroupMemberHandler
{
  onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void;
  onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void;
}

export class ManageGroupView extends UIComponentViewImpl<UIDataModel> implements ManageGroupMemberHandler
{
  private groupNameComponent: any;
  private viewModel: MemberDetailsViewModelImpl;
  private popupComponent: PopUpWrapperComponent;
  
  constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
  {
      super(applicationContext, uiComponentHandler);

      this.onAddMemberClicked = this.onAddMemberClicked.bind(this);
      this.onDeleteMemberClicked = this.onDeleteMemberClicked.bind(this);
      this.viewModel = new MemberDetailsViewModelImpl(5, applicationContext, this);
  }

    bindHandlers()
    {
      this.onBackClicked = this.onBackClicked.bind(this);
      this.onCancelClicked = this.onCancelClicked.bind(this);
      this.onSaveClicked = this.onSaveClicked.bind(this);
      this.onEditClicked = this.onEditClicked.bind(this);
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
    }

    draw(uiProps: ManageGroupProps, uiState: ManageGroupState, cssStyle: ManageGroupCSSStyleImpl): JSX.Element 
    {
        super.draw(uiProps, uiState, cssStyle);

        return uiState.manageGroupType === ManageGroupType.VIEW ? this.getViewGroupCSS(uiProps, uiState, cssStyle) : this.getCreateGroupCSS(uiProps, uiState, cssStyle);
    }

    getViewGroupCSS(uiProps: ManageGroupProps, uiState: ManageGroupState, cssStyle: ManageGroupCSSStyleImpl): JSX.Element 
    {
      this.viewModel.setListDatas(uiState.listOfGroupMembers);
      this.viewModel.setManageGroupType(uiState.manageGroupType);
      return (
        <div id="manage-group-main" style={cssStyle.getWrapperCSSStyle()}>
          <label id="manage-group-title"  style={cssStyle.getGroupTitleCSSStyle()}>{uiProps.context.getResources().getString(Strings.view_group)}</label>

          <div id="manage-group-groupname" style={cssStyle.getGroupNameCSSStyle()}>
              <TextComponent hint={uiProps.context.getResources().getString(Strings.group_name)} maxLength={this.getUIProps().context.getResources().getString(Strings.group_name_max_length)} label={uiProps.context.getResources().getString(Strings.group_name)} placeholder={uiProps.context.getResources().getString(Strings.group_name)}  isDisabled={true} ref={(item: any) => this.groupNameComponent = item} id={"#username"} value={uiState.groupName} inputType={"text"} isRequired={false}  context={uiProps.context} emptyErrorMsg={uiProps.context.getResources().getString(Strings.invalid_group)}/> 
          </div>
          <div id="manage-group-members" style={cssStyle.getGroupMembersCSSStyle()}>
          {
              <VerticalListComponent listViewModel={this.viewModel} context={uiProps.context}/>}
          </div>
          <div id="manage-group-list" style={{display: "inline-block"}}>
          <div id="manage-group-button-main" style={{display: "flex", flexFlow: "row wrap"}}>
              <div id="manage-group-button"  style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onBackClicked} style={new GroupButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.back)}/>
            </div>
            <div id="manage-group-button" style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onEditClicked} style={new ButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.edit)}/>
              </div>
              
          </div>
          </div>
          <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={uiProps.context}/>
        </div>  
     );
    }

    getCreateGroupCSS(uiProps: ManageGroupProps, uiState: ManageGroupState, cssStyle: ManageGroupCSSStyleImpl): JSX.Element 
    {
      this.viewModel.setListDatas(uiState.listOfGroupMembers);
      this.viewModel.setManageGroupType(uiState.manageGroupType);
      
      return (
        <div id="manage-group-main" style={cssStyle.getWrapperCSSStyle()}>
          <label id="manage-group-title" style={cssStyle.getGroupTitleCSSStyle()}>{uiState.manageGroupType === ManageGroupType.CREATE ? uiProps.context.getResources().getString(Strings.create_group) : uiProps.context.getResources().getString(Strings.edit_group)}</label>

          <div id="manage-group-groupname" style={cssStyle.getGroupNameCSSStyle()}>
              <TextComponent hint={uiProps.context.getResources().getString(Strings.group_name)} maxLength={this.getUIProps().context.getResources().getString(Strings.group_name_max_length)} label={uiProps.context.getResources().getString(Strings.group_name)} placeholder={uiProps.context.getResources().getString(Strings.group_name)}  isDisabled={false} ref={(item: any) => this.groupNameComponent = item} id={"#username"} value={uiState.groupName} inputType={"text"} isRequired={true}  context={uiProps.context} emptyErrorMsg={uiProps.context.getResources().getString(Strings.invalid_group)}/> 
          </div>
          <div id="manage-group-members" style={cssStyle.getGroupMembersCSSStyle()}>
          {
              <VerticalListComponent listViewModel={this.viewModel} context={uiProps.context}/>}
          </div>
          <div id="manage-group-list" style={{display: "inline-block"}}>
          <div id="manage-group-button-main" style={{display: "flex", flexFlow: "row wrap"}}>
            <div id="manage-group-button" style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onSaveClicked} style={new ButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.save)}/>
              </div>
              
              <div id="manage-group-button" style={cssStyle.getButtonDivCSSStyle()}>
                <ButtonComponent onClick={this.onCancelClicked} style={new GroupButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.cancel)}/>
            </div>
          </div>
          </div>
          <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={uiProps.context}/>
        </div>  
     );
    }

    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
      console.log("onDeleteClicked: " + memberDetailsDto.getMemberName());

      if(this.viewModel.getListOfDatas().length === 2)
      {
         this.showPopup(this.getContext().getResources().getString(Strings.please_add_atleast_one_member_to_your_group), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else
      {
        (this.getUIComponentHandler() as ManageGroupHandler).onDeleteMemberClicked(memberDetailsDto, this.groupNameComponent.getData());
      }
    }

    onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
      console.log("onAddMemberClicked: " + memberDetailsDto.getMsisdn());

      if(memberDetailsDto.getMemberName().length === 0)
      {
         this.showPopup(this.getContext().getResources().getString(Strings.member_name_is_mandatory), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else if(memberDetailsDto.getMsisdn().length  === 0)
      {
        this.showPopup(this.getContext().getResources().getString(Strings.mobile_number_is_mandatory), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
      }
      else
      {
        let isExists = this.viewModel.getListOfDatas().findIndex((t: MemberDetailsDto, index: number)=>
          {
              return t.getMsisdn() === memberDetailsDto.getMsisdn();
          });

          if(isExists === -1)
          {
            (this.getUIComponentHandler() as ManageGroupHandler).onAddMemberClicked(memberDetailsDto, this.groupNameComponent.getData());
          }
          else
          {
            this.showPopup(this.getContext().getResources().getString(Strings.mobile_number_must_be_unique), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
          }
      }
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }

    hidePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }

    private onBackClicked()
    {
       (this.getUIProps() as ManageGroupProps).onBackClicked();
    }

    private onCancelClicked()
    {
      (this.getUIProps() as ManageGroupProps).onCancelClicked();
    }

    private onSaveClicked()
    {
      if(this.groupNameComponent !== null && this.groupNameComponent.validate())
      {
        
        if((this.getUIState() as ManageGroupState).listOfGroupMembers.length === 1)
        {
          this.showPopup(this.getContext().getResources().getString(Strings.please_add_atleast_one_member_to_your_group), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
        }
        else
        {

          // (this.getUIState() as ManageGroupState).listOfGroupMembers.shift();

          (this.getUIState() as ManageGroupState).manageGroupType === ManageGroupType.CREATE ? 
              (this.getUIComponentHandler() as ManageGroupHandler).onCreateGroupClicked(this.groupNameComponent.getData())
          :
              (this.getUIComponentHandler() as ManageGroupHandler).onEditGroupClicked(this.groupNameComponent.getData());
        }
      }
    }
     
    private onEditClicked()
    {
      (this.getUIComponentHandler() as ManageGroupHandler).showEditMode();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/managegroupview.tsx